import { InfoIcon } from 'lucide-react';

import { InfoTooltip } from '@/components/atoms/InfoTooltip/InfoTooltip';
import { Toggle } from '@/components/ui/toggle';

interface DetailsPanelToggleProps {
  pressed: boolean;
  onPressedChange: (next: boolean) => void;
  tooltip: string;
}

// Toggle has no icon-only size yet — overrides give it a square shape and a
// visible pressed-state, neither of which the text-tuned defaults provide.
export const DetailsPanelToggle = ({
  pressed,
  onPressedChange,
  tooltip,
}: DetailsPanelToggleProps) => (
  <InfoTooltip content={tooltip}>
    <Toggle
      pressed={pressed}
      onPressedChange={onPressedChange}
      size="sm"
      className="size-9 border border-border bg-background px-0 text-muted-foreground hover:bg-muted"
    >
      <InfoIcon size={16} />
      <span className="sr-only">{tooltip}</span>
    </Toggle>
  </InfoTooltip>
);
